"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var noop_1 = tslib_1.__importDefault(require("lodash/fp/noop"));
var find_1 = tslib_1.__importDefault(require("lodash/fp/find"));
var get_1 = tslib_1.__importDefault(require("lodash/fp/get"));
var curryN_1 = tslib_1.__importDefault(require("lodash/fp/curryN"));
var Select_1 = require("../Select");
var PLXTimeZones_1 = tslib_1.__importDefault(require("./PLXTimeZones"));
var IANATimeZones_1 = tslib_1.__importDefault(require("./IANATimeZones"));
var DEFAULT_PARSE = curryN_1.default(2, function (options, iana) {
    return find_1.default({ value: iana }, options);
});
var DEFAULT_FORMAT = function (option) { return get_1.default('value', option); };
var TimeZonePicker = function (_a) {
    var _b, _c;
    var _d = _a.onChange, onChange = _d === void 0 ? noop_1.default : _d, _e = _a.value, value = _e === void 0 ? 'America/Chicago' : _e, _f = _a.enablePLXCompatibilityMode, enablePLXCompatibilityMode = _f === void 0 ? false : _f, rest = tslib_1.__rest(_a, ["onChange", "value", "enablePLXCompatibilityMode"]);
    var options = enablePLXCompatibilityMode ? PLXTimeZones_1.default : IANATimeZones_1.default;
    var parse = (_b = rest.parse) !== null && _b !== void 0 ? _b : DEFAULT_PARSE(options);
    var format = (_c = rest.format) !== null && _c !== void 0 ? _c : DEFAULT_FORMAT;
    var _g = react_1.useState(parse(value)), timeZone = _g[0], setTimeZone = _g[1];
    var handleChange = function (newTimeZone) {
        setTimeZone(newTimeZone);
        onChange(format(newTimeZone));
    };
    return (react_1.default.createElement(Select_1.Select, tslib_1.__assign({}, rest, { options: options, value: timeZone, onChange: handleChange })));
};
TimeZonePicker.displayName = 'FOS_TimeZonePicker';
exports.default = TimeZonePicker;
